import React from 'react'
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";

const ThreadKeyMapping = () => {
  return (
    <div className="grow">
    <SideMenu />
    <div className="wrapper flex grow flex-col">
      <Header />
      <main className="grow content" id="content" role="content">
        <div className="container-fixed">
          <div className="card-header text-center">
            <h3 className="card-title">Thread Key Mapping</h3>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-custom">
                <div className="card-body">
                  <div className="row mt-4">
                    <div className="col-md-4">
                      <MuiSearchSelect
                        placeholder={"Please Enter Branch"}
                        label='Branch'
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiSearchSelect
                        placeholder={"Please Enter Client ID"}
                        label='Client ID'
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4">
                     <MuiInput placeholder='Please Enter User ID' label={"User ID"}/>
                     
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiInput
                        label="Business Unit"
                        placeholder="Business Unit"
                      />
                    </div>
          
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                      marginTop: "8px",
                    }}
                  >
                    <div className="user-button w-full">
                      <MuiButton
                        className="clear-btn "
                        label="Clear"
                        type="submit"
                      />
                      <MuiButton
                        label={"SUBMIT"}
                        className="main-btn get-btn"
                        variant="contained"
                        size="large"
                        type="submit"
                      />
                    </div>
                    {/* <MuiButton
                    label={editingUser ? "Update User" : "Create User"}
                    className="main-btn"
                    variant="contained"
                    size="large"
                    onClick={() => formik.handleSubmit()}
                  /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  )
}

export default ThreadKeyMapping
